import { AppConfig } from "./appConfig";

export const UrlConfig = {
    ip: {
        info: AppConfig.ngmApiDomain + "/map/ip/info",
    },

    auth: {
        logout: `${window.location.origin}/Auth/Logout`,
        login: `${window.location.origin}/Auth/Login`,
    },

    poiEdit: {
        create: `${AppConfig.ngmApiDomain}/map/v3/place-edit/createV3`,
        requestDelete: AppConfig.ngmApiDomain + '/map/v3/place-edit/delete-place-v3',
    },

    roadEdit: {
        create: `${AppConfig.ngmApiDomain}/map/v2/road-edit/update-basic`,
        requestDelete: `${AppConfig.ngmApiDomain}/map/v2/road-edit/delete`,
    },

    boundaryEdit: {
        create: `${AppConfig.ngmApiDomain}/map/region-edit`,
        requestDelete: `${AppConfig.ngmApiDomain}/map/region-edit/delete`,
    },

    poi: {
        autosuggest: AppConfig.ngmApiDomain + "/maps/api/place/queryautocomplete/json",
        detail: AppConfig.ngmApiDomain + "/maps/api/place/details/json",
        search: `${AppConfig.ngmApiDomain}/maps/api/place/textsearch/json`,
        basicDetail: AppConfig.ngmApiDomain + "/map/place/{id}",
        getListByTag: `${AppConfig.ngmApiDomain}/map/place/get-place-by-tags-paging`,
        searchByText: `${AppConfig.ngmApiDomain}/map/place/text-search`,
        aroundLocation: `${AppConfig.ngmApiDomain}/map/place/around-locations`,
    },

    place: {
        request: AppConfig.ngmApiDomain + '/map/v3/place-edit',
        nearbySearch: AppConfig.ngmApiDomain + "/map/place/nearby-search",
        alongRoute: AppConfig.ngmApiDomain + "/map/place/along-route",
    },

    placeGroup: {
        getByUser: AppConfig.ngmApiDomain + '/map/place-group',
        create: AppConfig.ngmApiDomain + '/map/place-group',
        saveToGroup: AppConfig.ngmApiDomain + '/map/place-group/save-place-to-list-group',
        updatePlaceDescription: AppConfig.ngmApiDomain + '/map/place-group/update-place-description',
        groupDetail: AppConfig.ngmApiDomain + '/map/place-group/detail/{id}',
        updateEntirety: AppConfig.ngmApiDomain + '/map/place-group/update-entirety-place-group',
        getSavedGroupsOfPlace: AppConfig.ngmApiDomain + "/map/place-group/get-list-by-placeid",
        deleteGroup: AppConfig.ngmApiDomain + '/map/place-group/{id}'
    },

    objectEdit: {
        create: `${AppConfig.ngmApiDomain}/map/v3/object-edit`,
        requestDelete: AppConfig.ngmApiDomain + "/map/v3/object-edit/delete-object"
    },

    object: {
        detail: AppConfig.ngmApiDomain + "/map/object/{id}",
        search: `${AppConfig.ngmApiDomain}/map/object/search`,
        route: `${AppConfig.ngmApiDomain}` + "/map/route",
        createMulti: AppConfig.ngmApiDomain + "/map/manage/object/list",
    },

    placeType: {
        detail: `${AppConfig.ngmApiDomain}/map/place-type/{id}`,
        getListSearch: `${AppConfig.ngmApiDomain}/map/place-type/list`,
        getList: `${AppConfig.ngmApiDomain}/map/place-type/get-list`,
        getListByGroupId: `${AppConfig.ngmApiDomain}/map/place-type/list-of-group/{groupId}`,
    },

    model: {
        list: `${AppConfig.ngmApiDomain}/map/model/all`,
    },

    tag: {
        filter: `${AppConfig.ngmApiDomain}/map/hash-tag/filter`,
        create: `${AppConfig.ngmApiDomain}/map/hash-tag`,
        createMany: `${AppConfig.ngmApiDomain}/map/hash-tag/create-many`,
        getByName: `${AppConfig.ngmApiDomain}/map/hash-tag/get-hashtag-by-names`,
    },

    file: {
        image: `${AppConfig.ngmApiDomain}/map/file/image`,
        listImage: `${AppConfig.ngmApiDomain}/map/file/list-images`,
        uploadModelFile: `${AppConfig.ngmApiDomain}/map/file/obj`,
        uploadTextureFile: `${AppConfig.ngmApiDomain}/map/file/texture`,
        listMedia: `${AppConfig.ngmApiDomain}/map/file/upload/list-media`,
    },

    geocode: {
        geocode: `${AppConfig.ngmApiDomain}/maps/api/geocode/json`,
        getAddressComponents: `${AppConfig.ngmApiDomain}/map/geocode/suggest-address-component`
    },

    userLabel: {
        get: AppConfig.ngmApiDomain + '/map/user-label',
        update: AppConfig.ngmApiDomain + '/map/user-label/update-default-label',
        delete: AppConfig.ngmApiDomain + '/map/user-label/delete-default-label/{userLabelType}'
    },

    reportError: {
        add: AppConfig.ngmApiDomain + '/map/report-error'
    },

    country: {
        getAllProvince: AppConfig.ngmApiDomain + "/map/country/province/all",
        getAllDistrict: AppConfig.ngmApiDomain + "/map/country/district",
        getAllSubdistrict: AppConfig.ngmApiDomain + "/map/country/subdistrict",
        getListCenterProvince: AppConfig.ngmApiDomain + "/map/country/province/get-list"
    },

    essentialService: {
        detail: AppConfig.ngmApiDomain + "/map/pec/{id}",
        search: AppConfig.ngmApiDomain + "/map/pec/search"
    },

    user: {
        detail: AppConfig.ngmApiDomain + "/map/user/info",
    },

    placeTypeGroup: {
        listAll: AppConfig.ngmApiDomain + "/map/place-type-group/all",
        search: AppConfig.ngmApiDomain + "/map/place-type-group/list",
    },
    direction: {
        route: AppConfig.ngmApiDomain + "/maps/api/directions/json",
    },
    searchHistory: {
        save: AppConfig.ngmApiDomain + "/map/place/history-search",
        get: AppConfig.ngmApiDomain + "/map/place/history-search"
    }
};
